import { Component, OnInit } from '@angular/core';
import { User } from '../../user.model';
import { UserService } from '../../user.service';
import { MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatSelectionList, MatListOption } from '@angular/material/list';

import { MatLine } from '@angular/material/core';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-select-users-multiple-dialog',
    templateUrl: './select-users-multiple-dialog.component.html',
    styleUrls: ['./select-users-multiple-dialog.component.css'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatSelectionList, MatListOption, MatLine, MatDialogActions, MatButton, MatDialogClose]
})
export class SelectUsersMultipleDialogComponent implements OnInit {

  Users: User[];
  constructor(private userSrv: UserService) { }

  ngOnInit(): void {
    this.userSrv.getUsersByRoles(['Test_Viewer']).subscribe(data=>{
      this.Users = data as User[];
      console.log(data);
    });

  }

}
